angular.module('crudService', [])
    .factory('Crud',['$http', '$rootScope',
        function ($http, $rootScope) {

        return {
            /* get models */
            index: function (path, offset, per_page) {
                return $http.get(path +'/index?page='+ offset +'&per_page='+ per_page);
            },

            /* save a model */
            save: function (content_type, modelData, path) {
                if(content_type == 'form-urlencoded') {
                    modelData['route'] = 'store';
                    return $http({
                        method: 'POST',
                        url: path + '/store',
                        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                        data: $.param(modelData)
                    });
                }
                if(content_type == 'undefined') {
                    modelData.append('route', 'store');
                    return $http({
                        method: 'POST',
                        url: path + '/store',
                        headers: {'Content-Type': undefined},
                        data: modelData
                    });
                }
                if(content_type == 'json') {
                    modelData['route'] = 'store';
                    return $http({
                        method: 'POST',
                        url: path + '/store',
                        headers: {'Content-Type': 'text/json'},
                        data: modelData
                    });
                }
            },

            /* show model */
            show: function (id, path) {
                return $http.get(path +'/show/' + id);
            },

            /* update model */
            update: function (content_type, modelData, typeId, path) {
                if(content_type == 'form-urlencoded') {
                    modelData['route'] = 'update';
                    return $http({
                        method: 'PATCH',
                        url: path +'/' + modelData[typeId],
                        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                        data: $.param(modelData)
                    });
                }
                if(content_type == 'undefined') {
                    modelData.append('route', 'update');
                    return $http({
                        method: 'PATCH',
                        url: path +'/' + modelData[typeId],
                        headers: {'Content-Type': undefined},
                        data: modelData
                    });
                }
                if(content_type == 'json') {
                    modelData['route'] = 'update';
                    return $http({
                        method: 'PATCH',
                        url: path +'/' + modelData[typeId],
                        headers: {'Content-Type': 'text/json'},
                        data: modelData
                    });
                }
            },

           /* update multiple models */
            updateMultiple: function (content_type, modelData, path) {
                if(content_type == 'form-urlencoded') {
                    modelData['route'] = 'updateMultiple';
                    return $http({
                        method: 'POST',
                        url: path +'/updateMultiple',
                        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                        data: $.param(modelData)
                    });
                }
                if(content_type == 'undefined') {
                    modelData.append('route', 'updateMultiple');
                    return $http({
                        method: 'POST',
                        url: path +'/updateMultiple',
                        headers: {'Content-Type': undefined},
                        data: modelData
                    });
                }
                if(content_type == 'json') {
                    modelData['route'] = 'updateMultiple';
                    return $http({
                        method: 'POST',
                        url: path +'/updateMultiple',
                        headers: {'Content-Type': 'text/json'},
                        data: modelData
                    });
                }
            },

            /* destroy model */
            destroy: function (id, path) {
                return $http.delete(path +'/' + id);
            },

            /* delete multiple models */
            deleteMultiple: function (modelData, path) {
                modelData['route'] = 'deleteMultiple';
                return $http({
                    method: 'POST',
                    url: path +'/deleteMultiple',
                    headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                    data: $.param(modelData)
                });
            },

            /* change status */
            changeStatus: function (modelData, path) {
                modelData['route'] = 'changeStatus';
                return $http({
                    method: 'POST',
                    url: path +'/changeStatus',
                    headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                    data: $.param(modelData)
                });
            },

            /* duplicate model */
            duplicate: function (modelData, path) {
                modelData['route'] = 'duplicate';
                return $http({
                    method: 'POST',
                    url: path +'/duplicate',
                    headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                    data: $.param(modelData)
                });
            },

            /* import request */
            import: function (content_type, model, path) {
                model['route'] = 'import';

                if(content_type == 'form-urlencoded') {
                    return $http({
                        method: 'POST',
                        url: path +'/import',
                        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                        data: $.param(model)
                    });
                }
                if(content_type == 'undefined') {
                    return $http({
                        method: 'POST',
                        url: path +'/import',
                        headers: {'Content-Type': undefined},
                        data: model
                    });
                }
                if(content_type == 'json') {
                    return $http({
                        method: 'POST',
                        url: path +'/import',
                        headers: {'Content-Type': 'text/json'},
                        data: model
                    });
                }
            },

            /* search */
            search: function (models, path, offset, per_page) {
                var modelData = models;
                modelData['route'] = 'search';
                return $http({
                    method: 'POST',
                    url: path +'/search?page='+ offset +'&per_page='+ per_page,
                    headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                    data: $.param(modelData)
                });
            },

            /* get dependent fields */
            getDependedFields: function (path) {
                return $http.get(path +'/dependedFields');
            },

            /* get request */
            get: function (path) {
                return $http.get(path);
            },

            /* post request */
            post: function (content_type, models, path) {
                if(content_type == 'form-urlencoded') {
                    return $http({
                        method: 'POST',
                        url: path,
                        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                        data: $.param(models)
                    });
                }
                if(content_type == 'undefined') {
                    //console.log(models);
                    return $http({
                        method: 'POST',
                        url: path,
                        headers: {'Content-Type': undefined},
                        data: models
                    });
                }
                if(content_type == 'json') {
                    return $http({
                        method: 'POST',
                        url: path,
                        headers: {'Content-Type': 'text/json'},
                        data: models
                    });
                }
            },






        };

    }]);
